module.exports = __webpack_public_path__ + "img/world-of-elements-icon.5c64c691.webp";